module.exports = __webpack_public_path__ + "img/platform-win.344ab97c.png";